import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AddressDTO, AddressType } from '@iota/iota-management-portal-v4-client';
import { deepCopy, DefaultAddress } from '../../constants-and-enums/default-objects';
import { AddressUpsertEvent } from '../address/address.component';

@Component({
    standalone: false,
    selector: 'app-address-list',
    templateUrl: './address-list.component.html',
    styleUrls: ['./address-list.component.scss']
})
export class AddressListComponent implements OnChanges {
    @Input() addresses: AddressDTO[];
    @Input() showAddressSubtitle = true;

    @Output() upsertAddress = new EventEmitter<AddressDTO>();
    @Output() deleteAddress = new EventEmitter<string>();

    updatedAddresses: AddressDTO[] = [];

    ngOnChanges(changes: SimpleChanges) {
        const newAddresses = changes?.['addresses']?.currentValue;

        if (newAddresses) {
            this.resetValues(newAddresses);
        }
    }

    resetValues(newAddresses?: AddressDTO[]) {
        const addressArray = newAddresses ? deepCopy(newAddresses) : deepCopy(this.addresses);

        const mainAddress = addressArray.find((addr) => addr.addressType === AddressType.MAIN_ADDRESS);
        const billingAddress = addressArray.find((addr) => addr.addressType === AddressType.BILLING_ADDRESS);

        this.updatedAddresses = [];
        if (mainAddress) {
            this.updatedAddresses.push(mainAddress);
        } else {
            this.updatedAddresses.push({ addressType: AddressType.MAIN_ADDRESS });
        }
        if (billingAddress) {
            this.updatedAddresses.push(billingAddress);
        }
    }

    addAddress() {
        const address: AddressDTO = DefaultAddress();
        address.addressType = AddressType.BILLING_ADDRESS;

        const invoiceIndex = this.updatedAddresses.findIndex((addr) => addr.addressType === AddressType.BILLING_ADDRESS);
        if (invoiceIndex !== -1) {
            this.updatedAddresses.splice(invoiceIndex + 1, 0, address);
        } else {
            this.updatedAddresses.push(address);
        }
    }

    saveAddress(upsertEvent: AddressUpsertEvent) {
        upsertEvent.callback(true);
        this.upsertAddress.emit(upsertEvent.address);
    }

    removeAddress(address: AddressDTO) {
        if (address.addressId) {
            this.deleteAddress.emit(address.addressId);
        } else {
            this.resetValues();
        }
    }

    invoiceAddressExists(): boolean {
        return this.updatedAddresses.some((address) => address.addressType === AddressType.BILLING_ADDRESS);
    }
}
